import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);
  // Close mobile menu when resizing to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024 && mobileMenuOpen) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [mobileMenuOpen]);
  return <header className="fixed top-0 left-0 w-full z-50 transition-all duration-300" data-id="element-81">
      <div className={`w-full backdrop-blur-md transition-all duration-300 ${scrolled ? 'bg-[#F7F2E9]/98 shadow-md py-2' : 'bg-[#F7F2E9]/95 py-4'}`} data-id="element-82">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 flex justify-between items-center" data-id="element-83">
          <Link to="/" className="flex items-center" data-id="element-84">
            <img src="https://assets.modern-commerce.io/modern_commerce_header_logo_1x.png" alt="Modern Commerce" className="h-5 w-auto" data-id="element-85" />
          </Link>

          <nav className="hidden lg:block" data-id="element-86">
            <ul className="flex items-center space-x-2" data-id="element-87">
              <li className="py-2" data-id="element-88">
                <Link to="/designandbuild" className="text-[#2C2416] hover:text-[#D4A574] transition-colors duration-300 font-medium" data-id="element-89">
                  Design & Build
                </Link>
              </li>
              <li className="text-[#8B7355] px-1" data-id="element-90">·</li>
              <li className="py-2" data-id="element-91">
                <Link to="/shopify-design-development" className="text-[#2C2416] hover:text-[#D4A574] transition-colors duration-300 font-medium" data-id="element-92">
                  Shopify
                </Link>
              </li>
              <li className="text-[#8B7355] px-1" data-id="element-93">·</li>
              <li className="py-2" data-id="element-94">
                <Link to="/shopify-pos" className="text-[#2C2416] hover:text-[#D4A574] transition-colors duration-300 font-medium" data-id="element-95">
                  Shopify POS
                </Link>
              </li>
              <li className="text-[#8B7355] px-1" data-id="element-96">·</li>
              <li className="py-2" data-id="element-97">
                <Link to="/digital-wallet" className="text-[#2C2416] hover:text-[#D4A574] transition-colors duration-300 font-medium" data-id="element-98">
                  Digital Wallet
                </Link>
              </li>
              <li className="text-[#8B7355] px-1" data-id="element-99">·</li>
              <li className="py-2" data-id="element-100">
                <Link to="/wine" className="text-[#2C2416] hover:text-[#D4A574] transition-colors duration-300 font-medium" data-id="element-101">
                  Wine
                </Link>
              </li>
              <li className="text-[#8B7355] px-1" data-id="element-102">·</li>
              <li className="py-2" data-id="element-103">
                <Link to="/about" className="text-[#2C2416] hover:text-[#D4A574] transition-colors duration-300 font-medium" data-id="element-104">
                  About
                </Link>
              </li>
              <li className="text-[#8B7355] px-1" data-id="element-105">·</li>
              <li className="py-2" data-id="element-106">
                <Link to="/contact" className="text-[#2C2416] hover:text-[#D4A574] transition-colors duration-300 font-medium" data-id="element-107">
                  Contact
                </Link>
              </li>
            </ul>
          </nav>

          <button className="lg:hidden text-[#2C2416] z-50" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-108">
            {mobileMenuOpen ?
          // X icon for close
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-109">
                <line x1="18" y1="6" x2="6" y2="18" data-id="element-110"></line>
                <line x1="6" y1="6" x2="18" y2="18" data-id="element-111"></line>
              </svg> :
          // Hamburger icon
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-112">
                <line x1="3" y1="12" x2="21" y2="12" data-id="element-113"></line>
                <line x1="3" y1="6" x2="21" y2="6" data-id="element-114"></line>
                <line x1="3" y1="18" x2="21" y2="18" data-id="element-115"></line>
              </svg>}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`fixed inset-0 bg-[#F7F2E9] z-40 transform transition-transform duration-300 ease-in-out ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} style={{
      top: '64px'
    }} data-id="element-116">
        <div className="px-12 py-8" data-id="element-117">
          <ul className="space-y-6" data-id="element-118">
            <li data-id="element-119">
              <Link to="/designandbuild" className="text-[#2C2416] text-2xl font-light tracking-[-1px] block py-2 border-b border-[#D4A57420]" onClick={() => setMobileMenuOpen(false)} data-id="element-120">
                Design & Build
              </Link>
            </li>
            <li data-id="element-121">
              <Link to="/shopify-design-development" className="text-[#2C2416] text-2xl font-light tracking-[-1px] block py-2 border-b border-[#D4A57420]" onClick={() => setMobileMenuOpen(false)} data-id="element-122">
                Shopify
              </Link>
            </li>
            <li data-id="element-123">
              <Link to="/shopify-pos" className="text-[#2C2416] text-2xl font-light tracking-[-1px] block py-2 border-b border-[#D4A57420]" onClick={() => setMobileMenuOpen(false)} data-id="element-124">
                Shopify POS
              </Link>
            </li>
            <li data-id="element-125">
              <Link to="/digital-wallet" className="text-[#2C2416] text-2xl font-light tracking-[-1px] block py-2 border-b border-[#D4A57420]" onClick={() => setMobileMenuOpen(false)} data-id="element-126">
                Digital Wallet
              </Link>
            </li>
            <li data-id="element-127">
              <Link to="/wine" className="text-[#2C2416] text-2xl font-light tracking-[-1px] block py-2 border-b border-[#D4A57420]" onClick={() => setMobileMenuOpen(false)} data-id="element-128">
                Wine
              </Link>
            </li>
            <li data-id="element-129">
              <Link to="/about" className="text-[#2C2416] text-2xl font-light tracking-[-1px] block py-2 border-b border-[#D4A57420]" onClick={() => setMobileMenuOpen(false)} data-id="element-130">
                About
              </Link>
            </li>
            <li data-id="element-131">
              <Link to="/contact" className="text-[#2C2416] text-2xl font-light tracking-[-1px] block py-2 border-b border-[#D4A57420]" onClick={() => setMobileMenuOpen(false)} data-id="element-132">
                Contact
              </Link>
            </li>
          </ul>

          <div className="mt-12 pt-6 border-t border-[#D4A57420]" data-id="element-133">
            <Link to="/contact" className="inline-flex items-center justify-center px-8 py-4 bg-[#2C2416] text-[#FAF7F2] rounded-full font-medium tracking-[0.5px] hover:bg-[#D4A574] transition-all duration-300" onClick={() => setMobileMenuOpen(false)} data-id="element-134">
              Get in touch
            </Link>
          </div>
        </div>
      </div>
    </header>;
}